import React from 'react';
import Slider from 'react-slick';
import { IAnnounce } from '../../utils/AnnounceInterfaces';

import { useTranslation } from 'react-i18next';
import AfriqHomeCard from '../components/layouts/AfriqHomeCard';
import { AnnouncesService } from './services/AnnounceService';

interface HotelCarouselProps {  
  onAddToFavorite: (itemId: string) => void;
  onRemoveToFavorite: (itemId: string) => void;
  user: any; // Use the appropriate user type
  searchType: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
  hotelId: string;
  commissionFee?: number;
}


const announceService = new AnnouncesService();
const HotelCarousel: React.FC<HotelCarouselProps> = ({
  onAddToFavorite,
  onRemoveToFavorite,
  user,
  searchType,
  hotelId,
  commissionFee
}) => {

  
  const [hotelAnnounces, setHotelAnnounces] = React.useState<IAnnounce[]>([]);

  React.useEffect(() => {
    //console.log("Fetching hotel announces for hotel ID:", hotelId);
    
    if (hotelId) {
        announceService.GetAnnouncesByHotel(hotelId)
            .then((data) => {
                //console.log("Fetched hotel announces:", data);
                setHotelAnnounces(data);
            })
            .catch((error) => console.error('Error fetching hotel announces:', error));
    }
}, [hotelId]);

  return (
     <div>
        <AfriqHomeCard
          announces={hotelAnnounces}
          user={user}
          changingFav={false}
          onAddToFavorite={(id) => console.log('Add to favorite', id)}
          onRemoveToFavorite={(id) => console.log('Remove from favorite', id)}
          searchTypeName={searchType}
          usage="hotelCarousel"
          commissionFee={commissionFee}
      />
    </div>

  );
};

export default HotelCarousel;
